
export default function Testimonial() {
  return (
    <section className="py-32 bg-gradient-to-b from-[#0A1628] to-[#0F2744]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-serif font-bold text-white mb-6">For Authors</h2>
          <p className="text-3xl font-serif text-gray-200 mb-8 leading-relaxed">
            당신의 'Creative'가<br />
            세상의 'Credit'이 되도록.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-[#0A1628] rounded-3xl p-12 shadow-xl border border-[#D4AF37]/20">
            <div className="space-y-8">
              {/* Quote 1 */}
              <div className="flex gap-6 group">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center">
                    <i className="ri-double-quotes-l text-2xl text-[#D4AF37]"></i>
                  </div>
                </div>
                <div>
                  <p className="text-xl text-gray-200 leading-relaxed">
                    우리는 원고 속에 숨겨진 <strong className="text-[#D4AF37]">당신만의 고유한 빛</strong>을 찾아냅니다.
                  </p>
                </div>
              </div>

              <div className="border-t border-[#D4AF37]/20"></div>

              {/* Quote 2 */}
              <div className="flex gap-6 group">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center">
                    <i className="ri-double-quotes-l text-2xl text-[#D4AF37]"></i>
                  </div>
                </div>
                <div>
                  <p className="text-xl text-gray-200 leading-relaxed">
                    단순히 책을 만드는 것을 넘어, <strong className="text-[#D4AF37]">저자의 메시지가 독자의 삶에 스며드는 과정</strong>을 함께 설계합니다.
                  </p>
                </div>
              </div>

              <div className="border-t border-[#D4AF37]/20"></div>

              {/* Quote 3 */}
              <div className="flex gap-6 group">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center">
                    <i className="ri-double-quotes-l text-2xl text-[#D4AF37]"></i>
                  </div>
                </div>
                <div>
                  <p className="text-xl text-gray-200 leading-relaxed">
                    크레딧과 함께, <strong className="text-[#D4AF37]">당신의 가치를 가장 전문적인 방식</strong>으로 세상에 증명하세요.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-12 pt-8 border-t border-[#D4AF37]/20 text-center">
              <a
                href="#contact"
                className="inline-flex items-center gap-3 bg-[#D4AF37] text-[#0A1628] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#F4D03F] transition-all hover:gap-4 cursor-pointer whitespace-nowrap"
              >
                함께 시작하기
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
